<template lang="html">
  <div class="floorplan-compare-selector contained-height"
  :class="{ 'make-white': selectedFloorplan }">
    <action-bar class="compare-action-bar"
    :class="{ 'make-white': selectedFloorplan }">
      <template slot="left">
        <button v-if="position === 'left'"
        class="btn-compare-back btn btn-link-action"
        @click="routerBack()">
          <i class="far fa-angle-left mr-2"></i> Back
        </button>
        <button v-if="selectedFloorplan && position === 'right'"
        class="btn btn-link-action"
        @click="deselectFloorplan()">
          <i class="fas fa-th-large"></i> Select
        </button>
      </template>
      <template slot="center">
        <div v-if="!floorplanId" class="gray b">
          <div v-if="showFavourites">
            Showing list of favourited floorplans.
          </div>
          <div v-else>
            Showing list of filtered floorplans.
          </div>
        </div>
      </template>
      <template slot="right">
        <button v-if="selectedFloorplan && position === 'left'"
        class="btn btn-link-action"
        @click="deselectFloorplan()">
          <i class="fas fa-th-large"></i> Select
        </button>
      </template>
    </action-bar>
    <transition name="fade" mode="out-in">
      <scrollable-content v-if="!floorplanId">
        <template>
          <floorplan-grid
          :floorplanList="filteredFloorplanList"
          @selected="selectFloorplan" />
        </template>
      </scrollable-content>
      <floorplan-compare-detail v-else :floorplan="selectedFloorplan"
      class="floorplan-compare-selector-content" />
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import ActionBar from '@/components/ActionBar';
import ScrollableContentComponent from '@/components/ScrollableContent';
import FloorplanCompareGrid from './FloorplanCompareGrid';
import FloorplanCompareDetail from './FloorplanCompareDetail';

export default {
  name: 'floorplan-compare-selector',
  props: {
    position: {
      type: String,
      default: 'left'
    },
    floorplanId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedFloorplan: null
    };
  },
  computed: {
    ...mapState({
      showFavourites: state => state.floorplans.showFavourites,
    }),
    ...mapGetters({
      filteredFloorplanList: 'floorplans/filteredFloorplanList',
      getFloorplanById: 'floorplans/getFloorplanById',
    })
  },
  methods: {
    ...mapMutations({
      setLeftFloorplanId: 'floorplans/compare/setLeftFloorplanId',
      setRightFloorplanId: 'floorplans/compare/setRightFloorplanId'
    }),
    deselectFloorplan() {
      this.selectedFloorplan = null;
      if (this.position === 'left') {
        this.setLeftFloorplanId('');
      } else {
        this.setRightFloorplanId('');
      }
    },
    selectFloorplan(floorplanId) {
      this.selectedFloorplan = this.getFloorplanById(floorplanId).current;
      if (this.position === 'left') {
        this.setLeftFloorplanId(floorplanId);
      } else {
        this.setRightFloorplanId(floorplanId);
      }
    },
    routerBack() {
      this.$router.go(-1);
    }
  },
  created() {
    if (this.floorplanId) {
      this.selectedFloorplan = this.getFloorplanById(this.floorplanId).current;
    }
  },
  components: {
    'action-bar': ActionBar,
    'scrollable-content': ScrollableContentComponent,
    'floorplan-grid': FloorplanCompareGrid,
    'floorplan-compare-detail': FloorplanCompareDetail
  },
};
</script>

<style lang="scss" scoped>
.floorplan-compare-selector {
  background-color: var(--background);
}

.compare-action-bar {
  background-color: var(--background);
}

.make-white {
  background-color: white;
}

.btn-compare-back {
  margin-left: -12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanCompare/FloorplanCompareSelector.vue